const colors = {
  white: '#fff',
  black: '#000',
  gray: {
    default: '#212121',
    dark: '#323a45',
    light: '#aeb0b5',
  },
  primary: {
    default: '#0071bc',
    dark: '#205493',
    darkest: '#112e51',
    light: '#d9ebf7',
    lightest: '#eaf3f9',
  },
  buttons: {
    default: '#07633B',
  },
  secondary: {
    highlight: {
      default: '#02bfe7',
      darkest: '#046b99',
      dark: '#00a6d2',
      light: '#9bdaf1',
      lightest: '#e1f3f8',
    },
    saturated: {
      default: '#e31c3d',
      darkest: '#981b1e',
      dark: '#cd2026',
      light: '#e59393',
      lightest: '#f9dede',
    },
  },
  muted: {
    //Currently tans
    darkest: '#39351b',
    dark: '#776f4a',
    mid: '#CABD9C',
    bright: '#dddac7',
    light: '#F8F7E9',
    highlight: '#eceade',
  },
  indicators: {
    high: '#FF3A0F',
    medium: '#E89602',
    low: '#189A77',
  },
}

const fonts = {
  body: '"Hind","Helvetica Neue",Helvetica,Arial,"Nimbus Sans L",sans-serif',
  heading:
    '"Open Sans","Helvetica Neue",Helvetica,Arial,"Nimbus Sans L",sans-serif',
}

export { colors, fonts }
